/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-unused-vars */
// userdataDB is an indexedDB instance to save auth info for background sync

const userDataDB = {
    setJWT: (token) => new Promise((resolve, reject) => {
        const request = indexedDB.open('userData', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore('tokens', { keyPath: 'name' });
            db.createObjectStore('userData', { keyPath: 'name' });
        }
        request.onerror = (e) => { reject(e.target.errorCode); }
        request.onsuccess = (e) => {
            const db = e.target.result;
            if (db) {
                const transaction = db.transaction('tokens', 'readwrite');
                const tokensStore = transaction.objectStore('tokens');

                // check if there is a row with JWT name, update it, otherwise, insert a new one with this name
                tokensStore.put({ name: 'JWT', value: token });

                transaction.oncomplete = () => {
                    db.close();
                    resolve();
                };
            }
            else { reject('Error on opening database!') }
        }
    }),
    getJWT: () => new Promise((resolve, reject) => {
        const request = indexedDB.open('userData', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore('tokens', { keyPath: 'name' });
            db.createObjectStore('userData', { keyPath: 'name' });
        }
        request.onerror = (e) => { reject(e.target.errorCode); }
        request.onsuccess = (e) => {
            const db = e.target.result;
            if (db) {
                const transaction = db.transaction('tokens', 'readonly');
                const tokensStore = transaction.objectStore('tokens');

                const data = tokensStore.get('JWT');

                transaction.oncomplete = () => {
                    db.close();
                    if (data.result) {
                        resolve({ success: true, token: data.result.value });
                    }
                    else {
                        reject({ success: false, error: 404 });
                    }
                };

            }
            else { reject('Error on opening database!') }
        }
    }),
    removeJWT: () => new Promise((resolve, reject) => {
        const request = indexedDB.open('userData', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore('tokens', { keyPath: 'name' });
            db.createObjectStore('userData', { keyPath: 'name' });
        }
        request.onerror = (e) => { reject(e.target.errorCode); }
        request.onsuccess = (e) => {
            const db = e.target.result;
            if (db) {
                const transaction = db.transaction('tokens', 'readwrite');
                const tokensStore = transaction.objectStore('tokens');

                tokensStore.delete('JWT');

                transaction.oncomplete = () => {
                    db.close();
                    resolve();
                };
            }
            else { reject('Error on opening database!') }
        }
    }),
    setUserId: (id) => new Promise((resolve, reject) => {
        const request = indexedDB.open('userData', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore('tokens', { keyPath: 'name' });
            db.createObjectStore('userData', { keyPath: 'name' });
        }
        request.onerror = (e) => { reject(e.target.errorCode); }
        request.onsuccess = (e) => {
            const db = e.target.result;
            if (db) {
                const transaction = db.transaction('userData', 'readwrite');
                const userDataStore = transaction.objectStore('userData');

                // check if there is a row with userId name, update it, otherwise, insert a new one with this name
                userDataStore.put({ name: 'userId', value: id });

                transaction.oncomplete = () => {
                    db.close();
                    resolve();
                };
            }
            else { reject('Error on opening database!') }
        }
    }),
    getUserId: () => new Promise((resolve, reject) => {
        const request = indexedDB.open('userData', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore('tokens', { keyPath: 'name' });
            db.createObjectStore('userData', { keyPath: 'name' });
        }
        request.onerror = (e) => { reject(e.target.errorCode); }
        request.onsuccess = (e) => {
            const db = e.target.result;
            if (db) {
                const transaction = db.transaction('userData', 'readwrite');
                const userDataStore = transaction.objectStore('userData');

                const data = userDataStore.get('userId');

                transaction.oncomplete = () => {
                    db.close();
                    if (data.result) {
                        resolve({ success: true, id: data.result.value });
                    }
                    else {
                        reject({ success: false, error: 404 });
                    }
                };

            }
            else { reject('Error on opening database!') }
        }
    }),
    removeUserId: () => new Promise((resolve, reject) => {
        const request = indexedDB.open('userData', 1);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore('tokens', { keyPath: 'name' });
            db.createObjectStore('userData', { keyPath: 'name' });
        }
        request.onerror = (e) => { reject(e.target.errorCode); }
        request.onsuccess = (e) => {
            const db = e.target.result;
            if (db) {
                const transaction = db.transaction('userData', 'readwrite');
                const userDataStore = transaction.objectStore('userData');

                userDataStore.delete('userId');

                transaction.oncomplete = () => {
                    db.close();
                    resolve();
                };
            }
            else { reject('Error on opening database!') }
        }
    })
};

export default userDataDB;
